// The intake's five Required Consents (form_9 keys and wording), in one place
// for the patient page (patientonboarding/PatientOnboarding.jsx), the staff
// view (OnBoardView.jsx) and the intake PDF (natvepdf.jsx). `brand` is
// config/practice.js intakeBrand(departmentid): the wording is C-HIM's, with
// the practice named as the intake's location names itself ("Center for
// Hypertension"; CODE intakes "Center for Obesity, Diabetes, and
// Endocrinology", same legal entity, owner 2026-10-18).
import { intakeBrand } from "../config/practice";

export function intakeConsents(brand = intakeBrand()) {
  const name = brand?.name || intakeBrand().name;
  return [
    {
      id: "privacyConsent",
      label: "I acknowledge that I have read and understand the HIPAA Privacy Notice and agree to the use and disclosure of my health information as described.",
    },
    {
      id: "aiScribeConsent",
      label: `I understand and consent to the use of AI scribes and automated documentation systems during my healthcare encounters at ${name}.`,
    },
    {
      id: "electronicConsent",
      label: "I consent to electronic communication and understand the risks associated with electronic transmission of health information.",
    },
    {
      id: "accuracyConsent",
      label: "I certify that all information provided in this registration form is accurate and complete to the best of my knowledge.",
    },
    {
      id: "treatmentConsent",
      label: `I consent to treatment and authorize ${name} to provide medical care and services.`,
    },
  ];
}
